// client/src/store/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, AuthState as BaseAuthState } from '../types/auth';

interface AuthState extends BaseAuthState {
    isLoading: boolean;
}

const initialState: AuthState = {
    user: null,
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    isLoading: true
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: User; token: string }>) => {
            const { user, token } = action.payload;
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;
            state.isLoading = false;
            localStorage.setItem('token', token);
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.isLoading = false;
            localStorage.removeItem('token');
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            if (!action.payload && !state.user) {
                state.isAuthenticated = false;
            }
        }
    }
});

export const { setCredentials, logout, setLoading } = authSlice.actions;
export default authSlice.reducer;